exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".years[data-v-af0a646c]{margin:10px auto;border-bottom:1px solid #253b6d;display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:center;align-items:center;height:40px}.years span[data-v-af0a646c]{color:#5a5a5a;font-size:.8em}@media (max-width:500px){.years span[data-v-af0a646c],main>p[data-v-af0a646c]{display:none}}.tabs[data-v-af0a646c]{min-width:250px}@media (max-width:900px){.tabs[data-v-af0a646c]{min-width:unset}}.tabs li[data-v-af0a646c]{padding:5px;width:-webkit-max-content;width:-moz-max-content;width:max-content;margin:0 5px;border-radius:5px 5px 0 0;background:#ececec;font-size:1.2em;display:inline-block;cursor:pointer}.tabs li[data-v-af0a646c]:hover{background:#bbb8b8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-af0a646c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./src/components/resume/Resume.vue
// module id = 1098
// module chunks = 0